module.exports = __webpack_public_path__ + "static/media/forex_sport_cra.77e22dc8.png";